// Gedeeld leeg-blok: gecentreerde kaart met (optioneel) icoon, titel, subtekst en
// een actie-slot. Basisstijl is overgenomen uit RankingView. Call-sites die iets
// afwijken (kaartpadding, icoongrootte) geven een merge-override mee via `style`
// of `iconStyle` zodat het uiterlijk exact gelijk blijft.
export default function EmptyState({ icon, title, sub, action, style, iconStyle }) {
  return (
    <div className="text-center py-20 px-6 bg-surface rounded-lg border border-line" style={style}>
      {icon != null && (
        <div className="flex justify-center mb-3 text-ink-3" style={iconStyle} aria-hidden="true">{icon}</div>
      )}
      {title != null && <div className="font-display text-[21px] tracking-[0.06em] font-bold text-ink-2 mb-2">{title}</div>}
      {sub != null && <div className="text-[14.5px] text-ink-3 max-w-[340px] mx-auto">{sub}</div>}
      {action}
    </div>
  );
}
